import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "./context/LanguageContext";
import { CartProvider } from "./context/CartContext";
import { WishlistProvider } from "./context/WishlistContext";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import WishlistPage from "./pages/WishlistPage";
import CartPage from "./pages/CartPage";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import Admin from "./pages/Admin";
import ShippingPage from "./pages/ShippingPage";
import ReturnsPage from "./pages/ReturnsPage";
import ContactPage from "./pages/ContactPage";
import FaqPage from "./pages/FaqPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import CookiePage from "./pages/CookiePage";
import AuthenticityPage from "./pages/AuthenticityPage";

export const SUPPORTED_LANGS = ["en", "nl", "de", "fr", "es", "it", "pl", "cs", "uk", "ru"];
export const DEFAULT_LANG = "en";

function detectBrowserLang() {
  const navLang = (typeof navigator !== "undefined" && navigator.language ? navigator.language : "")
    .toLowerCase()
    .slice(0, 2);
  return SUPPORTED_LANGS.includes(navLang) ? navLang : DEFAULT_LANG;
}

function App() {
  const pathname = typeof window !== "undefined" ? window.location.pathname : "/";
  const firstSeg = pathname.split("/").filter(Boolean)[0];
  const urlLang = SUPPORTED_LANGS.includes(firstSeg) ? firstSeg : null;

  // No lang prefix — redirect to /{stored||detected}/{rest}
  if (!urlLang && typeof window !== "undefined") {
    const stored = localStorage.getItem("ll_lang");
    const targetLang = SUPPORTED_LANGS.includes(stored) ? stored : detectBrowserLang();
    const rest = pathname === "/" ? "" : pathname;
    const newUrl = `/${targetLang}${rest}${window.location.search}${window.location.hash}`;
    window.location.replace(newUrl);
    return null;
  }

  return (
    <HelmetProvider>
    <LanguageProvider initialLang={urlLang || DEFAULT_LANG}>
      <CartProvider>
        <WishlistProvider>
          <BrowserRouter basename={`/${urlLang || DEFAULT_LANG}`}>
            <div className="min-h-screen flex flex-col bg-[#FDFBF7]">
              <Header />
              <main className="flex-1 pt-16 md:pt-20">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/shop" element={<Shop />} />
                  <Route path="/product/:id" element={<ProductDetail />} />
                  <Route path="/wishlist" element={<WishlistPage />} />
                  <Route path="/cart" element={<CartPage />} />
                  <Route path="/checkout/success" element={<CheckoutSuccess />} />
                  <Route path="/admin" element={<Admin />} />
                  <Route path="/shipping" element={<ShippingPage />} />
                  <Route path="/returns" element={<ReturnsPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/faq" element={<FaqPage />} />
                  <Route path="/privacy" element={<PrivacyPage />} />
                  <Route path="/terms" element={<TermsPage />} />
                  <Route path="/cookies" element={<CookiePage />} />
                  <Route path="/authenticity" element={<AuthenticityPage />} />
                </Routes>
              </main>
              <Footer />
            </div>
            <Toaster position="bottom-right" />
          </BrowserRouter>
        </WishlistProvider>
      </CartProvider>
    </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
